"use client";
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import Header from "./Header";
import { AppSidebar } from "./Sidebar";
import { SidebarProvider, SidebarInset } from "./ui/sidebar";

export default function AdminLayout({
  children,
}) {
  const { isAuthenticated, hasRole, user, loading } = useAuth();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {    
    console.log('AdminLayout - Authentication check:');
    console.log('- isAuthenticated:', isAuthenticated());
    console.log('- hasRole(admin):', hasRole('admin'));
    console.log('- user:', user);
    console.log('- loading:', loading);
    
    if (loading) {
      console.log('AdminLayout - Still loading authentication...');
      return;
    }
    
    if (!isAuthenticated() || (!hasRole('admin') && !hasRole('super_admin'))) {
      console.log('AdminLayout - Not authenticated or not admin/super_admin, redirecting to login');
      window.location.href = "/login";
    } else {
      console.log('AdminLayout - Authenticated as admin/super_admin, mounting layout');
      setMounted(true);
    }
  }, [isAuthenticated, hasRole, user, loading]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="relative">
          <div className="w-20 h-20 border-4 border-muted border-t-primary rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  if (!mounted) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="w-20 h-20 border-4 border-muted border-t-primary rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0 max-w-full overflow-x-hidden">
        <Header />
        <div className="app-page flex flex-1 flex-col gap-2 md:gap-4 pt-0 pb-4 md:pb-6 min-w-0 overflow-hidden">
          {children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
